import { toast, ToastOptions, TypeOptions } from "react-toastify";

type ToastProps = {
  type: string;
  message: string | JSX.Element;
};

export const Toast = ({ type, message }: ToastProps) => {
  const classNameVar =
    "bg-slate-600 p-2 rounded-md shadow-md w-[400px] md:right-12 z-[30000]";
  let progressClassNameVar = "";
  if (type === "success") {
    progressClassNameVar = "bg-green-700";
  } else if (type === "error") {
    progressClassNameVar = "bg-orange-700";
  } else if (type === "info") {
    progressClassNameVar = "bg-blue-700";
  }

  function properlyFormatted() {
    if (type === "success") {
      return (
        <div className="flex flex-col pl-2">
          <div className="absolute z-10 grid text-white -translate-y-1/2 rounded-full shadow-lg place-items-center -left-12 top-1/2 size-20 bg-gradient-to-r from-green-700 to-green-900">
            <div className="italic font-medium text-green-200">Success</div>
          </div>
          <p className="text-sm font-medium text-brown-200">{message}</p>
        </div>
      );
    }
    if (type === "error") {
      return (
        <div className="flex flex-col pl-2">
          <div className="absolute z-10 grid text-white -translate-y-1/2 rounded-full shadow-lg place-items-center -left-12 top-1/2 size-20 bg-gradient-to-r from-orange-700 to-orange-900">
            <div className="italic font-medium text-orange-200">Error</div>
          </div>
          <p className="text-sm font-medium text-brown-200">{message}</p>
        </div>
      );
    }
    return (
      <div className="flex flex-col pl-2">
        <div className="absolute z-10 grid text-white -translate-y-1/2 rounded-full shadow-lg place-items-center -left-12 top-1/2 size-20 bg-gradient-to-r from-blue-700 to-blue-900">
          <div className="italic font-medium text-blue-200">Info</div>
        </div>
        <p className="text-sm font-medium text-brown-200">{message}</p>
      </div>
    );
  }

  const parameters: ToastOptions = {
    type: type as TypeOptions,
    className: classNameVar,
    progressClassName: progressClassNameVar,
    icon: undefined,
    closeOnClick: true,
    closeButton: false,
  };
  if (message && message !== "") {
    toast(properlyFormatted, parameters);
  }
};

export default Toast;
